import type { CSSProperties } from "react";

import { SearchTabs } from "app/components/React/QuickSearch/types";
import {
    ALL_TAB_TITLE,
    KEYWORD_TAB_TITLE,
    REPORTS_TAB_TITLE,
    WEBSITE_TAB_TITLE,
} from "app/components/React/SearchAutocompleteWithTabs/texts";

export const SEARCH_TAB_DICTIONARY = {
    [SearchTabs.All]: { id: SearchTabs.All, title: ALL_TAB_TITLE },
    [SearchTabs.Website]: { id: SearchTabs.Website, title: WEBSITE_TAB_TITLE },
    [SearchTabs.Keyword]: { id: SearchTabs.Keyword, title: KEYWORD_TAB_TITLE },
    [SearchTabs.Reports]: { id: SearchTabs.Reports, title: REPORTS_TAB_TITLE },
};

export const TAB_LIST: SearchTabs[] = [SearchTabs.All, SearchTabs.Website, SearchTabs.Keyword, SearchTabs.Reports];

export const ALL_TAB_PREVIEW_ITEM_COUNT = 3;

export const ALL_TAB_EXPANDED_MAX_ITEM_COUNT = 10;

export const ALL_TAB_CATALOG_SUMMARY_SEARCH_LIMIT = 24;

export const QUICK_SEARCH_MODAL_WIDTH_DEFAULT_PX = 544;

export const REPORTS_TAB_ITEM_COUNT = 8;

export const AUTOCOMPLETE_DEBOUNCE = 250;

export const QUICK_SEARCH_MODAL_FIXED_HEIGHT_PX = 540;

export const QUICK_SEARCH_BOT_STRIP_HEIGHT_PX = 48;

export const QUICK_SEARCH_MODAL_CHROME_ABOVE_TAB_SCROLL_PX = 115;

export const QUICK_SEARCH_TAB_PANEL_SCROLL_MAX_HEIGHT_PX =
    QUICK_SEARCH_MODAL_FIXED_HEIGHT_PX - QUICK_SEARCH_MODAL_CHROME_ABOVE_TAB_SCROLL_PX;

export const getQuickSearchModalStyles = (
    contentWidthPx: number,
    contentHeightPx: number = QUICK_SEARCH_MODAL_FIXED_HEIGHT_PX,
): { content: CSSProperties } => ({
    content: {
        width: `${contentWidthPx}px`,
        height: `${contentHeightPx}px`,
        background: "transparent",
        border: "none",
        padding: 0,
        display: "flex",
        flexDirection: "column",
    },
});
